import { render, staticRenderFns } from "./Turn.vue?vue&type=template&id=38879875&scoped=true&lang=pug&"
import script from "./Turn.vue?vue&type=script&lang=js&"
export * from "./Turn.vue?vue&type=script&lang=js&"
import style0 from "./Turn.vue?vue&type=style&index=0&id=38879875&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38879875",
  null
  
)

export default component.exports